/* Diabec analytics + Google Consent Mode v2 default-deny scaffold.
   Load this in <head> on every page BEFORE diabec-cookie-banner.js, with NO defer/async,
   so the consent default is set before any tracking tag fires.

   To activate Google Analytics 4: replace G-XXXXXXXXXX with your real measurement ID
   and uncomment the GA4 loader block below.

   To activate Meta Pixel / TikTok / Klaviyo: listen for the 'diabec:consent' custom
   event dispatched by diabec-cookie-banner.js — its detail is { analytics, marketing }.
*/
(function () {
    // gtag stub (queues calls until/if GA4 loads)
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

    // Consent Mode v2 — default everything to denied until the user opts in.
    // EU/UK/CH get strict default; everywhere else gets the same default (safer).
    gtag('consent', 'default', {
        analytics_storage:    'denied',
        ad_storage:           'denied',
        ad_user_data:         'denied',
        ad_personalization:   'denied',
        functionality_storage:'granted',
        security_storage:     'granted',
        wait_for_update:      500
    });

    gtag('set', 'url_passthrough', true);
    gtag('set', 'ads_data_redaction', true);

    // GA4 measurement-tag insertion happens in diabec-pixels.js when the user
    // grants analytics consent; default-deny above keeps Consent Mode v2 happy
    // until that event fires.
})();
